import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function initHero() {
    document.addEventListener('DOMContentLoaded', function () {
        const swiper = new Swiper('.cmp-hero__swatch-wrapper--mobile.swiper', {
          slidesPerView: 4.2,
          spaceBetween: 10,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      });
}